import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoginPage } from '@/components/auth/LoginPage';
import { useOrgBranding } from '@/hooks/useOrgBranding';

export default function AuthPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading, guestBlocked } = useAuth();
  const { logoUrl, orgName } = useOrgBranding();

  // Deep links (e.g. the booking key link in SMS/email) arrive here when the
  // customer is not signed in; return them to that page after login. Only
  // same-origin paths are honoured so the param can never redirect off-site.
  const next = searchParams.get('next');
  // En bokningsgäst som nekats (AuthContext) landar här med ?blocked=guest.
  const guestNotice = guestBlocked || searchParams.get('blocked') === 'guest';
  const returnTo = next && next.startsWith('/') && !next.startsWith('//') ? next : '/keys';

  useEffect(() => {
    if (!loading && user) {
      navigate(returnTo, { replace: true });
    }
  }, [user, loading, navigate, returnTo]);

  if (loading) {
    return (
      <main className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </main>
    );
  }

  return (
    <>
      {guestNotice && (
        <div
          role="status"
          className="mx-4 mt-4 rounded-2xl border border-amber-300/60 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:bg-amber-950/40 dark:text-amber-200"
        >
          <p className="font-semibold">Det här kontot är en bokningsgäst</p>
          <p className="mt-1">
            Din nyckel öppnas via länken i bekräftelsen du fick per SMS eller e-post — ingen
            inloggning behövs. Åtkomst-appen är för användare som bjudits in av sin organisation.
          </p>
        </div>
      )}
      <LoginPage orgName={orgName ?? undefined} orgLogoUrl={logoUrl ?? undefined} />
    </>
  );
}
